export default {
  tableFields: [
    {
      name: '__component:badge-column',
      title: '',
      dataClass: 'text-center'
    },
    {
      name: 'hosting_id',
      title: 'id',
      sortField: 'hosting_id'
    },
    {
      name: 'hostname',
      title: 'server',
      sortField: 'hostname'
    },
    {
      name: 'vm_nics',
      title: 'IPv4',
      callback: 'formatIp'
    },
    {
      name: 'status',
      title: 'status',
      callback: 'formatVmStatus'
    },
    {
      name: '__component:manage-custom-actions',
      title: '',
      titleClass: 'center aligned',
      dataClass: 'center aligned'
    }
  ],
  sortFunctions: {
    'hosting_id': function (item1, item2) {
      console.log(item1)
      return item1 >= item2 ? 1 : -1
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/data-visualisation-tab/fields-definition.js